// Valores padrão, estados iniciais etc...

interface IDefault {
  table: {
    page_size: number
  }
}

export default Object.freeze<IDefault>({
  table: {
    page_size: 15
  }
})
